import React from 'react';
import { MdCheck, MdPix } from 'react-icons/md';

// Ilustração do sistema montada em HTML (decorativa): agenda + pagamento + portaria.
const diasSemana = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
const reservados = [4, 5, 11, 18, 19, 25];
const indisponiveis = [7, 14, 21, 28];
const selecionado = 12;

export default function PreviaSistema() {
  const dias = Array.from({ length: 31 }, (_, i) => i + 1);

  return (
    <div aria-hidden='true' className='relative mx-auto w-full max-w-md select-none'>
      <div className='rounded-2xl border border-zinc-200 bg-white p-5 shadow-card'>
        <div className='flex items-center justify-between'>
          <div>
            <p className='text-xs text-zinc-500'>Churrasqueira 2</p>
            <p className='font-semibold text-zinc-900'>Outubro</p>
          </div>
          <span className='rounded-full bg-zinc-100 px-2.5 py-1 text-xs font-medium text-zinc-600'>Área de lazer</span>
        </div>

        <div className='mt-4 grid grid-cols-7 gap-1 text-center text-[11px] text-zinc-400'>
          {diasSemana.map((d, i) => <span key={i}>{d}</span>)}
        </div>
        <div className='mt-1 grid grid-cols-7 gap-1 text-center text-sm'>
          {/* Outubro começando na terça */}
          <span /><span />
          {dias.map(dia => {
            let classe = 'text-zinc-700';
            if (reservados.includes(dia)) classe = 'bg-zinc-100 text-zinc-400 line-through';
            if (indisponiveis.includes(dia)) classe = 'text-zinc-300';
            if (dia === selecionado) classe = 'bg-zinc-900 font-semibold text-white';
            return (
              <span key={dia} className={`flex aspect-square items-center justify-center rounded-lg ${classe}`}>
                {dia}
              </span>
            );
          })}
        </div>

        <div className='mt-4 flex items-center justify-between rounded-xl bg-zinc-50 px-4 py-3'>
          <div>
            <p className='text-xs text-zinc-500'>Sábado, 12/10</p>
            <p className='font-semibold text-zinc-900'>R$ 150,00</p>
          </div>
          <span className='flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700'>
            <MdPix className='h-3.5 w-3.5' />
            Pago
          </span>
        </div>
      </div>

      <div className='absolute -bottom-8 -left-4 w-56 rounded-2xl border border-zinc-200 bg-white p-4 shadow-card sm:-left-10'>
        <p className='text-xs font-medium uppercase tracking-wider text-zinc-500'>Portaria</p>
        <p className='mt-1 text-sm font-semibold text-zinc-900'>Convidados</p>
        <div className='mt-2 flex items-center justify-between text-xs text-zinc-500'>
          <span>Check-in</span>
          <span className='font-medium text-zinc-900'>18 / 25</span>
        </div>
        <div className='mt-1.5 h-1.5 overflow-hidden rounded-full bg-zinc-100'>
          <div className='h-full w-[72%] rounded-full bg-emerald-500' />
        </div>
        <ul className='mt-3 space-y-1.5 text-xs text-zinc-700'>
          <li className='flex items-center gap-2'>
            <MdCheck className='h-4 w-4 text-emerald-600' />Maria S.
          </li>
          <li className='flex items-center gap-2'>
            <MdCheck className='h-4 w-4 text-emerald-600' />João P.
          </li>
        </ul>
      </div>

      <div className='absolute -right-2 -top-4 hidden rounded-full border border-zinc-200 bg-white px-3 py-1.5 text-xs font-medium text-zinc-700 shadow-card sm:block'>
        <span className='mr-1.5 inline-block h-2 w-2 rounded-full bg-emerald-500' />
        Nova reserva confirmada
      </div>
    </div>
  );
}
